export default __webpack_public_path__ + "static/media/proyek-group.ed6a1ded.png";